module.exports = __webpack_public_path__ + "static/itsbandtime-568076becabc3ddcc318b7c5ae90b09c.jpg";